import { createFileRoute, redirect } from "@tanstack/react-router";

// Portal's `_protected.admin.account-settings._index` — redirect to the default (account-info) tab.
export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/admin/account-settings/",
)({
  loader: ({ params }) => {
    throw redirect({
      to: "/$locale/{-$schoolyear}/admin/account-settings/account-info",
      params: { locale: params.locale, schoolyear: params.schoolyear },
    });
  },
});
